<template>
  <div>
    <div v-if="image || webcam" class="tw-mb-4">
      <a @click="back" class="tw-text-blue-600">
        <i class="fa fa-arrow-left"></i>&nbsp;&nbsp;Voltar
      </a>
    </div>
    <div class="row btn-alternatives">
      <div v-if="!image && !webcam">
        <div v-if="currentImage" class="tw-text-center tw-mb-4">
          <img :src="currentImage" class="tw-mx-auto tw-mb-2 tw-rounded-full" />
          <a
            :href="url"
            data-method="delete"
            class="hover:tw-no-underline tw-text-gray-700 hover:tw-text-gray-900"
          >
            <i class="fa fa-trash-o"></i> Apagar imagem
          </a>
        </div>
        <div class="col-sm-6">
          <button
            class="btn btn-blue photo-crop-upload-load-image-button tw-float-right"
            @click="loadWebcam"
          >
            <i class="fa fa-camera tw-mr-1"></i> Tirar foto
          </button>
        </div>
        <div class="col-sm-6">
          <span
            class="btn btn-blue photo-crop-upload-load-image-button tw-float-left"
            @click="$refs.file.click()"
          >
            <input
              type="file"
              ref="file"
              @change="loadFile($event)"
              accept="image/*"
              style="display: none"
            />
            <i class="fa fa-picture-o tw-mr-1"></i> Escolher Imagem
          </span>
        </div>
      </div>
    </div>
    <div v-if="webcam">
      <div v-if="camLoadMessage">
        <div
          class="tw-bg-gray-200 tw-border-l-4 tw-border-gray-500 tw-text-gray-700 tw-p-4"
          role="alert"
        >
          <p class="tw-font-bold">Permita o acesso a câmera</p>
          <p>
            É necessário permitir que o Codental acesse a cêmera do seu computador para continuar. Uma mensagem é mostrada na parte superior logo abaixo a barra de endereço, clique no botão
            <strong>"Permitir"</strong>.
          </p>
        </div>
      </div>
      <div v-if="camNotAllowAccess">
        <div
          class="tw-bg-red-100 tw-border-l-4 tw-border-red-500 tw-text-red-700 tw-p-4"
          role="alert"
        >
          <p class="tw-font-bold">O Codental não tem autorização para acessar sua câmera</p>
          <p>
            Não foi possível acessar câmera. Para habilitar o acesso do Codental a sua câmera, siga esse procedimento:
            <a
              class="tw-text-red-700 hover:tw-text-red-900 tw-underline"
              href="https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DAndroid&hl=pt-BR"
              target="_blank"
            >Alterar as permissões da câmera</a>
          </p>
        </div>
      </div>
      <div v-if="camGenericError">
        <div
          class="tw-bg-red-100 tw-border-l-4 tw-border-red-500 tw-text-red-700 tw-p-4"
          role="alert"
        >
          <p class="tw-font-bold">Ocorreu um erro ao acessar sua câmera</p>
          <p>Verifique se sua câmera está ligada e conectada ao computador.</p>
        </div>
      </div>
      <video ref="video" class="tw-w-3/4 tw-m-0 tw-m-auto"></video>
      <div class="text-center tw-mt-4">
        <button class="btn btn-primary" @click="takePhoto">Tirar foto</button>
      </div>
      <canvas ref="photo" class="photo" style="display: none;"></canvas>
    </div>
    <div v-if="image">
      <p v-if="loading" class="photo-crop-upload-loading">Carregando imagem...</p>

      <div class="col-sm-8">
        <small
          v-if="!loading"
          class="tw-block tw-mb-2 tw-text-xs"
        >Arraste os pontos para ajustar a imagem</small>
        <cropper :src="image" @change="onChange" :stencil-props="{ aspectRatio: 1 }" />
      </div>
      <div class="text-center col-sm-4">
        <small v-if="!loading" class="tw-block tw-mb-2 tw-text-xs">Como a imagem vai aparecer</small>
        <div>
          <canvas
            ref="preview"
            if="preview"
            width="500"
            height="500"
            class="photo-crop-upload-preview-image"
          ></canvas>
        </div>
        <button v-if="!loading" class="btn btn-primary tw-mt-2" @click="upload">Salvar</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["currentImage", "url", "patientUrl"],
  data() {
    return {
      image: null,
      preview: null,
      webcam: false,
      loading: false,
      camLoadMessage: false,
      camNotAllowAccess: false,
      camGenericError: false
    };
  },
  methods: {
    loadFile(event) {
      let input = event.target;

      if (input.files && input.files[0] && validateImageSize(input.files[0])) {
        this.loading = true;
        var reader = new FileReader();
        reader.onload = e => {
          this.image = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      } else {
        alert('Ocorreu um erro ao carregar a imagem.')
      }
    },
    loadWebcam() {
      this.webcam = true;
      // fix this
      this.camLoadMessage = true;
      if (navigator.mediaDevices) {
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: false })
          .then(localMediaStream => {
            this.camLoadMessage = false;
            this.$refs.video.srcObject = localMediaStream;
            this.$refs.video.play();
          })
          .catch(err => {
            this.camLoadMessage = false;
            if (
              err.name == "NotAllowedError" ||
              err.name == "PermissionDeniedError"
            ) {
              this.camNotAllowAccess = true;
            } else {
              this.camGenericError = true;
            }
          });
      }
    },
    back() {
      this.webcam = false;
      this.image = null;
      this.preview = null;
      this.camNotAllowAccess = false;
      this.camLoadMessage = false;
    },
    takePhoto() {
      const self = this;
      const width = this.$refs.video.videoWidth;
      const height = this.$refs.video.videoHeight;
      this.$refs.photo.width = width;
      this.$refs.photo.height = height;
      const context = this.$refs.photo.getContext("2d");
      context.drawImage(this.$refs.video, 0, 0, width, height);
      this.image = this.$refs.photo.toDataURL();
      this.webcam = false;
    },
    onChange({ canvas }) {
      const previewContext = this.$refs.preview.getContext("2d");
      previewContext.drawImage(canvas, 0, 0, 500, 500);
      this.preview = true;
      this.loading = false;
    },
    upload() {
      event.target.innerHTML = "Aguarde...";
      event.target.disabled = true;
      axios
        .put(this.url, {
          authenticity_token: document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
          photo: this.$refs.preview.toDataURL()
        })
        .then(response => {
          window.location.href = this.patientUrl;
        });
    }
  }
};

function validateImageSize(image) {
  if (image.size > 15000000) {
    return false;
  }
  return true;
}
</script>
